// Our own custom icons to be added to the feather icons iconset
// Add to @/assets/icons
export default {
  bird: { name: 'bird' },
  cat: { name: 'cat' },
  dog: { name: 'dog' },
  mammal: { name: 'mammal' },
  other: { name: 'other' },
  reptile: { name: 'reptile' },
  pdf: { name: 'pdf' },
  'long-arrow-up': { name: 'long-arrow-up' },
  'long-arrow-down': { name: 'long-arrow-down' },
  'long-arrow-right': { name: 'long-arrow-right' },
  'long-arrow-left': { name: 'long-arrow-left' },
  'coat-length': { name: 'coat-length' },
  weight: { name: 'weight' },
  tiktok: { name: 'tiktok' },
}
